const path = require('path')

const router = require('../../router')


module.exports = (graphql, actions, route) => {
  const { createPage } = actions
  const template = path.resolve('src/templates/Demo/index.js')

  createPage({
    path: router(route.path, { locale: 'fr' }),
    component: template,
    context: {
      langKey: 'fr',
    },
  })

  createPage({
    path: router(route.path, { locale: 'en' }),
    component: template,
    context: {
      langKey: 'en',
    },
  })
}
